export default {"src":"/_next/static/media/routing.3457ca59.svg","height":76,"width":76};